import React from 'react';

import { RenderRoutes } from './RenderRoutes';

import 'src/assets/fonts.css';

const App = () => {
  return <RenderRoutes />;
};

export default App;
